import { FC } from "react";
import { OptionItem } from "../model";
import CHECK_ICON from "@/assets/icons/check.svg";

interface OptionItemTextPropTypes {
  value: OptionItem | undefined;
  option: OptionItem;
  onClickOption: (optionItem: OptionItem) => void;
}

const OptionItemText: FC<OptionItemTextPropTypes> = ({
  value,
  option,
  onClickOption,
}) => {
  return (
    <div
      className={
        "option-item" +
        (value && option.value === value.value ? " selected" : "")
      }
      onClick={() => onClickOption(option)}
    >
      <label>{option.label}</label>
      {value && option.value === value.value && (
        <img src={CHECK_ICON} alt="chec-icon" />
      )}
    </div>
  );
};

export default OptionItemText;
